<template>
  <div class="bg_white boxs2 pl16 pr16 pt15 pb16">
    <h2 class="page_title ab c5a">口座情報の登録・変更（書面）</h2>
    <div v-if="!submitted" class="mt20 c5a">
      <p>書面にて振替口座をお手続きされる方は以下の「申し込む」を押してください。後日、振替依頼書を郵送にてお届けいたします。</p>
      <p class="mt10">「毎月口座引落し払い」で使用する口座をご変更する場合、ボーナスの振込口座も変更となります。</p>
      <p class="mt10">なお、書面での口座引き落としのお手続きには約2ヶ月かかり、定期購入の場合、お手続きまで代金引換でのお届けとなりますのでご了承ください。</p>
      <div class="btn_wrap mt32">
        <button type="button" class="btn_yellow" @click="onApply" :disabled="loading">
          <span v-if="!loading">申し込む</span>
          <span v-else>送信中...</span>
        </button>
      </div>
      <div class="mt16">
        <button class="btn_delete" type="button" @click="goBackOneStep">戻る</button>
      </div>
      <p v-if="errorMessage" class="mt16 c5a">{{ errorMessage }}</p>
    </div>
    <div v-else class="mt20 c5a">
      <p>書面の申請を受け付けました。振替依頼書の到着をお待ちください。</p>
      <div class="mt16">
        <button class="btn_delete" type="button" @click="goBackOneStep">戻る</button>
      </div>
    </div>
  </div>
</template>

<script>
import BankAccount from '@/components/api/bankAccount';

export default {
  name: 'MemberBankAccountUsePaper',
  data() {
    return {
      loading: false,
      submitted: false,
      errorMessage: '',
    }
  },
  methods: {
    async onApply() {
      this.loading = true;
      this.errorMessage = '';
      try {
        const res = await BankAccount.registerDocument('TRANSFER_REQUEST');
        // 成功判定はAPIの仕様に依存。典型的な 'OK' または truthy を許容。
        if (res === 'OK' || (res && res.status === 'OK') || res === true) {
          this.submitted = true;
        } else {
          this.errorMessage = '申請に失敗しました。時間を置いて再度お試しください。';
        }
      } catch (e) {
        this.errorMessage = '通信エラーが発生しました。時間を置いて再度お試しください。';
      } finally {
        this.loading = false;
      }
    },
    goBackOneStep() {
      if (window.history && window.history.length > 1) {
        this.$router.back();
      } else {
        this.$router.push({ name: 'MemberBankAccountUse' });
      }
    }
  }
}
</script>

<style scoped>
.btn_wrap {
  margin-top: 24px;
}
</style>




// WEBPACK FOOTER //
// src/views/member/bankAccount/UsePaper.vue